export default "__VITE_ASSET__CW1jDa$8__"